import React from 'react';
import {useNavigate} from 'react-router-dom';
import {EditEmailDrawer, ProfileAlertsBanner, ProfileData, useProfile} from 'features/profile';
import {ROUTES} from 'app/router/routes';
import styles from './ProfileDataPage.module.css';

const backIcon = (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<path d="M10 6L4 12L10 18" stroke="currentColor" strokeWidth="1.6" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M20 12.9135L5 12.9135L5 11.1992L20 11.1992L20 12.9135Z"
			fill="currentColor"
		/>
	</svg>
);

export function ProfileDataPage(): React.ReactElement {
	const navigate = useNavigate();
	const {profile, isLoading, isError, error, isSuccess} = useProfile();
	const [isEditEmailOpen, setIsEditEmailOpen] = React.useState(false);

	const handleBack = () => {
		navigate(ROUTES.profile);
	};

	return (
		<div className={styles.root}>
			<header className={styles.header}>
				<button type="button" className={styles.backButton} onClick={handleBack} aria-label="Назад">
					{backIcon}
				</button>
				<h1 className={styles.title}>Данные</h1>
			</header>

			<div className={styles.content}>
				<div className={styles.contentInner}>
					<ProfileAlertsBanner />
					{isLoading ? <p className={styles.stateText}>Загрузка профиля...</p> : null}
					{isError ? (
						<p className={styles.errorText}>
							{error instanceof Error ? error.message : 'Не удалось загрузить профиль'}
						</p>
					) : null}
					{isSuccess ? <ProfileData profile={profile} onEditEmail={() => setIsEditEmailOpen(true)} /> : null}
				</div>
			</div>

			{isSuccess ? (
				<EditEmailDrawer
					open={isEditEmailOpen}
					initialEmail={profile.email}
					onClose={() => setIsEditEmailOpen(false)}
				/>
			) : null}
		</div>
	);
}
